/**
 * @description Diagram events const
 */
export const DIAGRAM_EMIT_EVENTS = {
    INVALID_PLUGIN_DROP: "INVALID_PLUGIN_DROP",
    INVALID_PLUGIN_MOVE: "INVALID_PLUGIN_MOVE",
    INVALID_CONNECTION_DRAGGED: "INVALID_CONNECTION_DRAGGED",

    PLUGIN_SELECTED: "PLUGIN_SELECTED",
    PLUGIN_DBLCLICK_SELECTED: "PLUGIN_DBLCLICK_SELECTED",
    // model changing
    PLUGIN_DELETED: "PLUGIN_DELETED",
    // model changing
    PLUGIN_CREATED: "PLUGIN_CREATED",
    CONNECTOR_SELECTED: "CONNECTOR_SELECTED",
    CONNECTOR_DBLCLICK_SELECTED: "CONNECTOR_DBLCLICK_SELECTED",
    // model changing
    CONNECTOR_DELETED: "CONNECTOR_DELETED",
    // model changing
    CONNECTOR_CREATED: "CONNECTOR_CREATED",

    PLUGIN_LABEL_CREATED: "PLUGIN_LABEL_CREATED",
    PLUGIN_LABEL_UPDATED: "PLUGIN_LABEL_UPDATED",
    // model changing
    CONNECTOR_LABEL_CREATED: "CONNECTOR_LABEL_CREATED",
    // model changing
    CONNECTOR_LABEL_UPDATED: "CONNECTOR_LABEL_UPDATED",
    DATA_MODEL_MENU_HEADER_ACTION: "DATA_MODEL_MENU_HEADER_ACTION",
    // model changing
    MULTIPLE_ACTIONS_HAPPENED: "MULTIPLE_ACTIONS_HAPPENED",
    INVALID_CONTAINER_RESIZE: "INVALID_CONTAINER_RESIZE",
    CONTAINER_ADD_CHILD: "CONTAINER_ADD_CHILD",
    SELECTED_CONTAINER_CHILD: "SELECTED_CONTAINER_CHILD",
    SELECTED_CONTAINER: "SELECTED_CONTAINER",
    EDIT_CONTAINER: "EDIT_CONTAINER",
    SELECTED_ANCHORED_PLUGIN: "SELECTED_ANCHORED_PLUGIN",

    API_CONTAINER_ADD_CHILD_ERROR: "API_CONTAINER_ADD_CHILD_ERROR",
    API_CONTAINER_REMOVE_CHILD_ERROR: "API_CONTAINER_REMOVE_CHILD_ERROR",
    API_CONTAINER_UPDATE_CHILD_ERROR: "API_CONTAINER_UPDATE_CHILD_ERROR",
    FAILED_CONTAINER_MOVE: "FAILED_CONTAINER_MOVE",
    CELL_INDEPENDENT_CONTAINER_ADDED: "CELL_INDEPENDENT_CONTAINER_ADDED",
    CELL_INDEPENDENT_CONTAINER_UPDATED: "CELL_INDEPENDENT_CONTAINER_UPDATED",
    CELL_INDEPENDENT_CONTAINER_REMOVED: "CELL_INDEPENDENT_CONTAINER_REMOVED",
    CONTAINER_CHILD_REMOVED: "CONTAINER_CHILD_REMOVED",
    CONTAINER_CHILD_ADDED: "CONTAINER_CHILD_ADDED",
    CONTAINER_CHILD_UPDATED: "CONTAINER_CHILD_UPDATED",
    // model changing
    CONTAINER_MOVED: "CONTAINER_MOVED",
    // model changing
    CONTAINER_RESIZE: "CONTAINER_RESIZE",
    // model changing
    VIEW_MODEL_LOADED: "VIEW_MODEL_LOADED",
    // model changing
    PLUGIN_MOVED: "PLUGIN_MOVED",
    DIAGRAM_VIEW_INITIALIZED: "DIAGRAM_VIEW_INITIALIZED",
    DIAGRAM_STATE_MODIFICATIONS: "DIAGRAM_STATE_MODIFICATIONS"

};
/**
 * @description Diagram events that change the model of the diagram. Used to track in history mode
 */
export const MODEL_CHANGING_EVENTS = [
    DIAGRAM_EMIT_EVENTS.PLUGIN_DELETED,
    DIAGRAM_EMIT_EVENTS.PLUGIN_CREATED,
    DIAGRAM_EMIT_EVENTS.CONNECTOR_DELETED,
    DIAGRAM_EMIT_EVENTS.CONNECTOR_CREATED,
    // DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_CREATED,
    DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_UPDATED,
    DIAGRAM_EMIT_EVENTS.MULTIPLE_ACTIONS_HAPPENED,
    // DIAGRAM_EMIT_EVENTS.CONTAINER_ADD_CHILD,
    DIAGRAM_EMIT_EVENTS.CELL_INDEPENDENT_CONTAINER_ADDED,
    DIAGRAM_EMIT_EVENTS.CELL_INDEPENDENT_CONTAINER_REMOVED,
    DIAGRAM_EMIT_EVENTS.CELL_INDEPENDENT_CONTAINER_UPDATED,
    DIAGRAM_EMIT_EVENTS.CONTAINER_CHILD_REMOVED,
    DIAGRAM_EMIT_EVENTS.CONTAINER_CHILD_ADDED,
    DIAGRAM_EMIT_EVENTS.CONTAINER_CHILD_UPDATED,
    DIAGRAM_EMIT_EVENTS.CONTAINER_RESIZE,
    DIAGRAM_EMIT_EVENTS.CONTAINER_MOVED,
    DIAGRAM_EMIT_EVENTS.PLUGIN_MOVED
    // DIAGRAM_EMIT_EVENTS.VIEW_MODEL_LOADED,
    // DIAGRAM_EMIT_EVENTS.DIAGRAM_VIEW_INITIALIZED
];
